const URL_PARAMETERS = {
  FLIGHT: 'flight',
  ROUTE: 'route',
};

const FLIGHT_MAP = {
  PROD: 'https://www.jetblue.com',
  MIDDLEPARAMS: '/FlightStatus/FlightMap.aspx?',
  DEPARTURE: 'departAirport',
  FLIGHTNO: 'flightNum',
  ETA: 'eta',
  DEPARTURETIME: 'departTime',
};

const FLIGHT_TRACKER_TAB_IDS = {
  byRouteTabID: 'BY_ROUTE',
  byFlightNoTabID: 'BY_NUMBER',
};

const REFRESH_VALUES = {
  initialLoad: 0,
  refreshEveryMS: 600000,
};

const MOBILE_APP_LINKS = {
  iOSResponse: 'iOS',
  androidResponse: 'Android',
  iOSLink: 'https://www.jetblue.com/mobile/iphone/appdownload/',
  androidLink: 'https://www.jetblue.com/mobile/android/appdownload/',
  otherLink: 'https://www.jetblue.com/mobile/',
};

const INVALID_CLASS = {
  invalidControlClass: 'invalid-control',
};

export const FLIGHT_TRACKER_CONFIG = {
  URL_PARAMETERS,
  FLIGHT_MAP,
  FLIGHT_TRACKER_TAB_IDS,
  REFRESH_VALUES,
  MOBILE_APP_LINKS,
  INVALID_CLASS,
};
